/**
 * Sawyer 08 meds-feeding — how one medication's times read, everywhere (profile,
 * editor, report, med pass). Principle 5: a time the server only inferred
 * from the frequency text says so; a medication with no time says so.
 */
import { humanizeFrequency } from '../dog-profile/format.js';
import { formatSlots } from '../../lib/care-labels.js';

export interface MedTimesInput {
  frequency: string | null;
  slots?: readonly string[] | null;
  effectiveSlots?: readonly string[] | null;
  slotSource?: 'set' | 'frequency' | 'frequency_default' | 'unscheduled';
}

/** "AM, PM" · "AM, PM (from frequency — set times to confirm)" · "Weekly (times not set)" · "Times not set". */
export function medTimesText(m: MedTimesInput): string {
  switch (m.slotSource) {
    case 'set':
      return formatSlots(m.slots ?? m.effectiveSlots);
    case 'frequency':
      return `${formatSlots(m.effectiveSlots)} (from frequency — set times to confirm)`;
    case 'frequency_default':
      return `${humanizeFrequency(m.frequency) ?? 'Frequency on file'} (times not set)`;
    case 'unscheduled':
      return 'Times not set';
    default:
      // An older server sends no times at all: show what it does send.
      return humanizeFrequency(m.frequency) ?? '';
  }
}

/** "Apoquel · 16 mg · AM, PM" */
export function medSummary(m: MedTimesInput & { name: string; dosage: string | null }): string {
  return [m.name, m.dosage, medTimesText(m)].filter((p) => p && p.trim().length > 0).join(' · ');
}
